export const getEventsItems = (state) => state.events.events
export const getIsLoadingEvents = (state) => state.events.isLoading
export const getEventsPagination = (state) => state.events.pagination
export const getFilterEvents = (state) => state.events.filter
